/*
|--------------------------------
| verify is object is empty or not
|--------------------------------
*/
export const objectIsEmpty = (obj) => {
  var objectLength = Object.keys(obj).length;
  return objectLength === 0 ? true : false;
};
